module.exports = "/_next/static/resources/photo-3-fe8f27608b17ff4e8411abb0b888137a.webp";